import {json, texture, padNum, delay} from "p3";
import common from "../../../common";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import settings from "../../../settings";
import CoinAnimation from "../misc/CoinAnimation";
import Item from "./Item";

export default class ItemAcorn extends Item {
    constructor(properties) {
        super(definitions.ITEM_ID.ACORN, texture("prop_acorn_00"));

        this._spinningCoins = [];

        this._properties = properties;
        this._instance = null;
    }

    init() {
        super.init();

        ////console.log('ACORN', this._properties);

        for (let i in this._properties) {
            if (this._properties[i].name == 'instance') {
                this._instance = this._properties[i].value;
            }
        }
        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }

    update() {
        for (let i = 0; i < this._spinningCoins.length; i++) {
            this._spinningCoins[i] && this._spinningCoins[i].update(window.dt);
        }

        super.update();
    }

    spawn() {
        if (common.saveData.activeSlot.acorns.indexOf(this._instance) < 0) {
            super.spawn();
        }
    }

    collect() {
        if (common.saveData.activeSlot.acorns.length == 0) {
            GameScene.active.assignQuestManually('acorns', 'badger');
        }
        else if(GameScene.active.questManager.isQuestComplete('acorns', 'badger') &&
                !GameScene.active.questManager.isQuestActive('acorns_2', 'badger')) {
            GameScene.active.assignQuestManually('acorns_2', 'badger');
        }
        if (common.saveData.activeSlot.acorns.indexOf(this._instance) < 0) {
            common.saveData.activeSlot.acorns.push(this._instance);
            common.saveData.saveGame();

            super.collect();

            const data = json('badger');

            let quest;
            if (GameScene.active.questManager.isQuestActive('acorns', 'badger')) {
                quest = 'acorns';
            } else if (GameScene.active.questManager.isQuestActive('acorns_2', 'badger')) {
                quest = 'acorns_2';
            }

            if(quest && common.saveData.activeSlot.acorns.length >= data.quests[quest].metadata.target) {
                GameScene.active.completeQuestManually(quest, 'badger');

                const max = Math.min(25, data.quests[quest].metadata.coinReward);

                for (let i = 0; i < max; i++) {
                    let frames = [];
    
                    for (let i = 0; i < 6; ++i) { 
                        frames[i] = texture("prop_gold_coin_" + padNum(i+1, 2)); 
                    }
    
                    const sequence = new P3.MovieClipSequence(frames, "idle");
    
                    this._spinningCoins[i] = new P3.MovieClip(sequence, "idle", false);
                    this._spinningCoins[i].anchor.set(0.5);
                    this.parent.addChild(this._spinningCoins[i]);
                    this._spinningCoins[i].animationSpeed = 10;
    
                    delay(i * 0.01, () => {
                        this._spinningCoins[i].gotoAndPlay("idle", true);
                    });
            
                    const position = GameScene.active.world.findSafePosition({x:this.x, y:this.y}, 150, 80, 20, [], 10);
    
                    GameScene.active.addTween(
                        gsap.to(this._spinningCoins[i], 0.5, {ease:Expo.easeInOut, motionPath: {
                            path: [
                                {x:0, y:-20}, 
                                {x:position.x/2, y:-100}, 
                                {x:position.x, y:position.y}
                            ]
                        }})
                    );
                }

                delay(1.0, () => {
                    for (let i = 0; i < this._spinningCoins.length; ++i) {
                        const target = settings.PHASE > 1 ? GameScene.active.hud.coinHolder : GameScene.active.hud.inventoryButton;
    
                        let chestHudCoords = target.toLocal(new PIXI.Point(this._spinningCoins[i].x, this._spinningCoins[i].y), this._spinningCoins[i].parent);
        
                        let coin = new PIXI.Sprite(texture('prop_gold_coin_01'));
                        coin.anchor.set(0.5);
                        coin.x = chestHudCoords.x;
                        coin.y = chestHudCoords.y - 100;
                        coin.visible = false;
                        coin.scale.set(1.3);
                        target.addChild(coin);
    
                        GameScene.active.addTween(
                            gsap.to(coin.scale, 0.25, {delay:i * 0.05, x: 1, y: 1, ease:Power0.easeIn})
                        );
                        GameScene.active.addTween(
                            gsap.to(coin, 0.5, {delay:i * 0.05, x: -60, y: 0, ease:Expo.easeOut, onStart:() => {                  
                                this._spinningCoins[i].visible = false;
                                P3.audio.playSound("sfx_pickup_coins");
                                coin.visible = true;
                                if (this.onUpdate) {
                                    this.onUpdate((i+1) / max);
                                }
                            }, onComplete:() => {
                                coin.visible = false;
                            }})
                        );
                    }
                });      

                // const coins = new CoinAnimation(data.quests[quest].metadata.coinReward, GameScene.active);
                // coins.x = this.x;
                // coins.y = this.y;
                // this.parent.addChild(coins);
                
                common.saveData.activeSlot.coins += data.quests[quest].metadata.coinReward;
                common.saveData.saveGame();
                GameScene.active.inventory.addItem(definitions.ITEM_ID.ACORN, data.quests[quest].metadata.target);
 
                if (GameScene.active.hud.coinHolder) {
                    GameScene.active.hud.coinHolder.coinAmount = common.saveData.activeSlot.coins;
                }

                return false;
            }

            return true;
        }
        return false;
    }
}